import { useEffect } from "react";
import HarmoniqIcon from "../Icons/harmoniqIcon.jsx";

export default function OAuthSuccess() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    const provider = params.get("provider");
    const userId = params.get("user_id");

    const finish = (payload) => {
      if (window.opener) {
        window.opener.postMessage(payload, window.location.origin);
      }
      setTimeout(() => {
        window.close();
      }, 300);
    };

    finish({
      type: "oauth_done",
      status,
      provider,
      user_id: userId,
    });
  }, []);

  return (
    <div className="app-route-loader" aria-live="polite" aria-busy="true">
      <HarmoniqIcon size={56} className="app-route-loader-icon" />
    </div>
  );
}
